/* File: assets/new-in-badge.js
   Fix: keeps full-res Shopify images intact; injects badge safely above image.
*/

(function () {
  'use strict';

  const TAG_TO_MATCH = 'new in';
  const SELECTOR_PRODUCT_LINKS = 'a[href*="/products/"]';
  const BADGE_HTML = '<div class="badge-new-in">NEW IN</div>';
  const CONCURRENCY = 6;

  function extractHandle(href) {
    try {
      const url = href.split('?')[0].split('#')[0];
      const parts = url.split('/');
      const idx = parts.indexOf('products');
      if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
    } catch (_) {}
    return null;
  }

  function lowerTrim(s) {
    return (s || '').toString().trim().toLowerCase();
  }

  function collectProductCards() {
    const nodes = Array.from(document.querySelectorAll(SELECTOR_PRODUCT_LINKS));
    const map = {};
    nodes.forEach((node) => {
      const handle = extractHandle(node.getAttribute('href') || '');
      if (!handle) return;
      const card =
        node.closest(
          '[data-product-id], .product-card, .card, .grid__item, .product-item'
        ) || node.parentElement;
      if (!map[handle]) map[handle] = [];
      if (!map[handle].includes(card)) map[handle].push(card);
    });
    return map;
  }

  function fetchProductJson(handle) {
    return fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: 'same-origin',
    }).then((r) => (r.ok ? r.json() : Promise.reject()));
  }

  function injectBadgeIntoCard(cardEl) {
    if (!cardEl || cardEl.querySelector('.badge-new-in')) return;

    const media =
      cardEl.querySelector(
        '.card__media, .product-card__media, .product-image'
      ) || cardEl;

    // Make sure we have a positioned container
    const style = getComputedStyle(media);
    if (style.position === 'static') media.style.position = 'relative';

    const badge = document.createElement('div');
    badge.innerHTML = 'NEW IN';
    badge.className = 'badge-new-in';
    badge.style.pointerEvents = 'none';
    media.appendChild(badge);
  }

  function processMap(handleMap) {
    const handles = Object.keys(handleMap);
    if (!handles.length) return;
    let index = 0,
      active = 0;

    function next() {
      while (active < CONCURRENCY && index < handles.length) {
        const handle = handles[index++];
        active++;
        fetchProductJson(handle)
          .then((p) => {
            const tags = Array.isArray(p.tags)
              ? p.tags
              : (p.tags || '').split(',').map((t) => t.trim());
            const hasTag = tags.some((t) => lowerTrim(t) === TAG_TO_MATCH);
            if (hasTag) handleMap[handle].forEach(injectBadgeIntoCard);
          })
          .finally(() => {
            active--;
            if (index < handles.length) next();
          });
      }
    }

    next();
  }

  function init() {
    const map = collectProductCards();
    processMap(map);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  const root = document.querySelector('main') || document.body;
  if (root) {
    const mo = new MutationObserver(() => setTimeout(init, 300));
    mo.observe(root, { childList: true, subtree: true });
  }
})();
